
import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import {environment} from "../../environments/environment";

@Component({
  selector: 'app-station-parameter-report',
  templateUrl: './station-parameter-report.component.html',
  styleUrls: ['./station-parameter-report.component.css']
})
export class StationParameterReportComponent implements OnInit {

  route:string;
  firstLevelExceedance:any = [];
  secondLevelExceedance:any = [];
  exceedanceIndustryList = [];
  industryParameterCount = [];
  exceedanceIndustryHistory = [];
  regionList = [];
  regionFilter = '';
  sum = 0;
  exceededSum = 0;
  selectedOfficerNameExceedance = '';
  selectedExceedanceStationIDs = '';
  selectedRegionNameExceedance = '';
  moreDetailDrilledExceedance = false;
  selectedIndustryNameExceedance = '';
  selectedIndustryAddressExceedance = '';
  regionLoaderExceedance = false;
  industryLoaderExceedance = false;
  historyLoaderExceedance = false;
  userData:any = [];
  currentDate=new Date;
  userName;
  userLevel;
  searchField = {};
  public apiBaseUrl: string = environment.apiBaseUrl;
  regionLoader = false;
  closeIndustryList = [];
  timeUnitList=[];
  industryList=[];
  vendorList=[];
  categoryList=[];
  stationList=[]
  industryParameterList = [];
  categoryFilter="";
  vendorFilter="";
  industryFilter=[];
  stationFilter=[];
  unitTypeFilter='';
  currentRoute: any;
  otherDetails={}
  industrySettings
  stationSettings


  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) {
  }

  ngOnInit() {

    this.userData = JSON.parse(localStorage.getItem('userData'));

    if (this.userData && this.userData['user_profile_id'] != undefined && this.userData['user_profile_id'] != 'IT001' && this.userData['user_profile_id'] != 'HSPCBCEMS') {
      this.router.navigate(['dashboard']);
    }
    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
    }

    if(this.userLevel == 'industry'){
      this.searchField['industryId'] = this.userName;
    }

    if(this.userLevel == 'vendor'){
      this.searchField['vendorId'] = this.userData['id']?this.userData['id']:'';
    }

    this.getExceededIndustry();
    this.getRegionList();
    this.settings();
   // this.getIndustryList();
   // this.getVendorList();
   // this.getCategoryList();
   // this.getStationList();
  }
  settings(){
    this.industrySettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1
    };
    this.stationSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1
    };
  }
  locationsSum() {
    return this.firstLevelExceedance.map(tag => tag.total_stations).reduce((a, b) => a + b, 0);
  }
  emmisionsSum() {
    return this.firstLevelExceedance.map(tag => tag.emmision).reduce((a, b) => a + b, 0);
  }
  effluentSum() {
    return this.firstLevelExceedance.map(tag => tag.effluent).reduce((a, b) => a + b, 0);
  }
  emmisionEffluentSum() {
    return this.firstLevelExceedance.map(tag => tag.emmision_effluent).reduce((a, b) => a + b, 0);
  }
  locationsExceededSum() {
    return this.firstLevelExceedance.map(tag => tag.total_exceedance_stations).reduce((a, b) => a + b, 0);
  }

  // tslint:disable-next-line:member-ordering
  secondLevelType = '';
  getStationIDs(key, type){
    this.secondLevelType = type;
    let stationIDs = '';
    if(this.firstLevelExceedance.length){
      for(let i=0; i < this.firstLevelExceedance.length; i++){
        if(this.firstLevelExceedance[i][key]){
          stationIDs = stationIDs+this.firstLevelExceedance[i][key]+',';
        }
      }
    }
    stationIDs = stationIDs.slice(-1)== ',' ? stationIDs.slice(0,-1) : stationIDs;
    this.getAggregateIndustryList(stationIDs,'get-station-parameter-list-region-wise', type);
    document.getElementById("openModalButton").click();

  }

  getExceedanceIndustryList(stationIDs){
    this.secondLevelType = '';
    this.industryLoaderExceedance = true;
    this.moreDetailDrilledExceedance = false;
    this.selectedExceedanceStationIDs = stationIDs;

    this.route  = 'get-station-parameter-list-region-wise';
    const token = localStorage.getItem('userToken');

    let data = { 'station_id':this.stationFilter.map((item)=>item.id).join(),
      'industry_id':this.industryFilter.map((item)=>item.id).join(),
      'vendor_id':this.vendorFilter,
      'category_type':this.categoryFilter,
      'region':this.regionFilter,
      'station_ids': this.selectedExceedanceStationIDs
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.secondLevelExceedance = response.result;
      }
      this.industryLoaderExceedance = false;
    });
  }


  getExceededIndustry(){

    this.regionLoaderExceedance = true;
    this.route  = 'get-station-parameter-region-wise';
    let data = { 'station_id':this.stationFilter.map((item)=>item.id).join(),
                'industry_id':this.industryFilter.map((item)=>item.id).join(),
                 'vendor_id':this.vendorFilter,
                 'category_type':this.categoryFilter,
                 'unit_type':this.unitTypeFilter,
                 'region':this.regionFilter
              };
    // console.log(data); return;
    const token = localStorage.getItem('userToken');
     this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){

        console.log(response.result);

        this.firstLevelExceedance = response.result;
      }
      this.regionLoaderExceedance = false;
    });
  }

  getAggregateIndustryList(stationIDs, route, type=null) {

    this.industryLoaderExceedance = true;
    this.moreDetailDrilledExceedance = false;
    this.selectedExceedanceStationIDs = stationIDs;

    const token = localStorage.getItem('userToken');

    let data = { 'station_id':this.stationFilter.map((item)=>item.id).join(),
      'industry_id':this.industryFilter.map((item)=>item.id).join(),
      'vendor_id':this.vendorFilter,
      'category_type':this.categoryFilter,
      'region':this.regionFilter,
      'station_ids': this.selectedExceedanceStationIDs,
      'emmision_type': type
    };

    this._service.postRequestCreator(data, route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.secondLevelExceedance = response.result;
      }
      this.industryLoaderExceedance = false;
    });
  }

  industryExceedanceHistoryData : any;

  getIndustryExceedanceHistory(val){

    this.industryExceedanceHistoryData = val;

      this.historyLoaderExceedance = true;
      this.moreDetailDrilledExceedance = true;
      this.selectedIndustryNameExceedance = this.industryExceedanceHistoryData.industry_name;
      this.selectedIndustryAddressExceedance = this.industryExceedanceHistoryData.industry_address;

      this.route  = 'get-station-industry-daily-report';
      const token = localStorage.getItem('userToken');

      let data = {
        'station_id':this.stationFilter,
        'station_ids':this.selectedExceedanceStationIDs,
        'industry_id':this.industryExceedanceHistoryData.industry_id,
        'vendor_id':this.vendorFilter,
        'category_type':this.categoryFilter,
        'region':this.regionFilter
      };

      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
          // location.reload();
        }
        if(response.status == 200){
          this.exceedanceIndustryHistory = response.result.data;
        }
        this.historyLoaderExceedance = false;
      });
  }


  backToPreviousLevelExceedance(){
    this.moreDetailDrilledExceedance = false;
  }

  region = "";
  industry_category = "";
  industry_type = "";
  vendorId = "";
  industry_id = "";
  station_id = "";

  getRegionList(){

    this.route  = 'get-region-list';
    const token = localStorage.getItem('userToken');

    let data = [];

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.regionList = response.data;
      }
      this.getCategoryList();
    }, error =>{
      this.getCategoryList();
    });
  }

  getCategoryList(region = null){


    this.route  = 'get-industry-categories';
    const token = localStorage.getItem('userToken');
    let data = {};
    if(region){
      this.region = region.target.value;
    } else{
      this.region = "";
    }
    data = {'region' : this.region};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.categoryList = response.data;
      }
      this.getTimeUnitList();
    }, error =>{
      this.getTimeUnitList();
    });

  }

  getTimeUnitList(industry_category = null){

    this.route  = 'get-industry-type';
    const token = localStorage.getItem('userToken');
    let data = {};
    if(industry_category){
      this.industry_category = industry_category.target.value;
    } else{
      this.industry_category = "";
    }
    data = {
      'region' : this.region,
      'industry_category' : this.industry_category
    };

    if(industry_category){
      data = {'industry_category' : industry_category.target.value};
    }
    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.timeUnitList = response.data;
      }
      this.getVendorList();
    }, error =>{
      this.getVendorList();
    });
  }

  getVendorList(industry_type = null){
    this.route  = 'get-vendor-list';
    const token = localStorage.getItem('userToken');
    let data = {};
    if(industry_type){
      this.industry_type = industry_type.target.value;
    } else{
      this.industry_type = "";
    }
    data = {
      'region' : this.region,
      'industry_category' : this.industry_category,
      'industry_type' : this.industry_type
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.vendorList = response.data;
      }
      this.getIndustryList();
    }, error =>{
      this.getIndustryList();
    });
  }

  getIndustryList(vendor_id = null){
    this.industryFilter=[]
    this.route  = 'get-all-industry-details';
    const token = localStorage.getItem('userToken');

    let data = {};
    if(vendor_id){
      this.vendorId = vendor_id.target.value;
    } else{
      this.vendorId = "";
    }

    let search_fields = {
      'region' : this.region,
      'categoryType' : this.industry_category,
      'industryType' : this.industry_type,
      'vendorId' : this.vendorId
    };

    data = {'search_fields' : search_fields}
    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.industryList = response.data;
      }
      this.getStationList();
    }, error =>{
      this.getStationList();
    });
  }

  getStationList(industry_id = null){
    this.stationFilter=[]
    this.route  = 'get-ind-station-details';
    const token = localStorage.getItem('userToken');
    let data = {};
    if(industry_id){
     this.industry_id= this.industryFilter.map((item)=>item.id).join();
      console.log(this.industry_id);
      console.log(this.industryFilter);
    } else{
      this.industry_id = "";
    }

    data = {
      'region' : this.region,
      'industry_category' : this.industry_category,
      'industry_type' : this.industry_type,
      'vendor_id' : this.vendorId,
      'industry_id' : this.industry_id
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.stationList = response.data;
      }
    }, error =>{
    });
  }

  exportReportFirstLevel(type) {
    var a;
    const token = localStorage.getItem('userToken');
    a = document.getElementById('export'+type+'hrefFirstLevel');
    a.href = this.apiBaseUrl +"/get-station-parameter-region-wise-export/"+type +"/"+token
      +"?industry_id="+(this.industryFilter ? btoa(this.industryFilter.map((item)=>item.id).join()) : btoa(null))
      +"&vendor_id="+(this.vendorFilter ? btoa(this.vendorFilter) : btoa(null))
      +"&unit_type="+(this.unitTypeFilter ? btoa(this.unitTypeFilter) : btoa(null))
      +"&category_type="+(this.categoryFilter ? btoa(this.categoryFilter) : btoa(null))
      +"&region="+(this.regionFilter ? btoa(this.regionFilter) : btoa(null))
      +"&station_id="+(this.stationFilter ? btoa(this.stationFilter.map((item)=>item.id).join()) : btoa(null));
    document.getElementById('export'+type+'hrefFirstLevel').click();
  }

  exportReportSecondLevel(type) {
    let a;
    const token = localStorage.getItem('userToken');
    a = document.getElementById('export'+ type + 'hrefSecondLevel');

    const route = '/get-station-parameter-list-region-wise-export/';

    const emissionTypeFilter = this.secondLevelType;

    a.href = this.apiBaseUrl + route + type + "/" + token
      +"?industry_id=" + (this.industryFilter ? btoa(this.industryFilter.map((item) => item.id).join()) : btoa(null))
      +"&station_id=" + (this.stationFilter ? btoa(this.stationFilter.map((item) => item.id).join()) : btoa(null))
      +"&vendor_id=" + (this.vendorFilter ? btoa(this.vendorFilter) : btoa(null))
      +"&unit_type=" + (this.unitTypeFilter ? btoa(this.unitTypeFilter) : btoa(null))
      +"&category_type=" + (this.categoryFilter ? btoa(this.categoryFilter) : btoa(null))
      +"&region=" + (this.regionFilter ? btoa(this.regionFilter) : btoa(null))
      +"&emmision_type=" + (emissionTypeFilter ? btoa(emissionTypeFilter) : btoa(null))
      +"&station_ids=" + (this.selectedExceedanceStationIDs ? btoa(this.selectedExceedanceStationIDs) : btoa(null));
    document.getElementById('export' + type + 'hrefSecondLevel').click();
  }

}

